<template>
  <div class="about">
    <div class="out d-flex flex-column">
      <header-secondary
        :fullHeader="true"
        :containerFluid="false"
        title="Политика обработки персональных данных"
      ></header-secondary>
      <main class="simple-page flex-grow-1">
        <section class="section">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <h3></h3>
                <p>
                  Пользуясь услугами вэб-сайта
                  <router-link to="/">exam</router-link>
                  (далее Сервис) вы предоставляете согласие на обработку всех
                  предоставленных вами данных с целью предоставления
                  качественного сервиса.
                </p>
                <p>
                  Принимая данную политику вы также подтверждаете, что
                  ознакомились с перечнем своих прав как субъекта данных.
                </p>

                <h5>1. Сбор личной информации</h5>
                <p>
                  1.1 При заполнеии контактных форм, регистрации или при
                  подписке на рассылку, пользователь предоставляет Сервису такие
                  данные как имя, фамилия, отчество, адрес элестронной почты,
                  которые являются необходимыми для предоставления услуг.
                </p>
                <p>
                  1.2 Пользователь самостоятельно и добровольно принимает
                  решение о предоставлении Сервису данных.
                </p>
                <p>
                  1.3 Сервис может использовать файлы cookies, веб-маяки и
                  другие подобные технологии для хранения информации. Данные
                  файлы используются с целью облегчить пользование веб-сайта и
                  его приложений, с целью повышения качества услуг Сервиса(в том
                  числе безопасности), а также в рекламных целях.
                </p>
                <p>
                  1.4 Сервис использует cookies и подобные технологии, которые
                  остаются на устройстве Пользователя в процессе активности
                  браузера Пользователя и cookies, а также другие подобные
                  технологии, которые остаются на устройстве Пользователя в
                  течение более длительного периода. Пользователь вправе
                  блокировать, удалять или отключать такие cookies иподобные
                  технологии, если устройство пользователя позволяет это.
                </p>
                <p>
                  1.5 при доступе на Сервис, серверы автоматически могут
                  записывать определенную информацию. Журналы сервера могут
                  содержать такую информацию, как веб-запрос, IP-адрес, тип и
                  язык браузера, дату и время запроса.
                </p>

                <h5>2. Защита информации</h5>
                <p>
                  2.1 Сервис принимает все разумные меры для защиты данных
                  пользователя от несанкционированного доступа третьих лиц. К
                  этим мерам относятся, в частности, внутренняя проверка
                  процессов сбора, хранения и обработки данных и мер
                  безопасности, включая соответствующее шифрование.
                </p>
                <p>
                  2.2 Пользователь обязуется сохранять свой пароль в секрете.
                  Пользователь несет ответственность за действия с
                  использованием своего электронного адреса и пароля, а также
                  действия, которые выполняются в личном кабинете пользователя.
                  Пользователь имеет право пользоваться услугами Сервиса только
                  с использованием своего собственного электронного адреса и
                  пароля. В случае если у Пользователя есть основания
                  подозревать о несанкционированном доступе к его личному
                  кабинету, Пользователь обязуется сменить самостоятельно свой
                  пароль.
                </p>
                <p>
                  2.3 Пользователь несет ответственность за точность и
                  правильность указанной им любой информации и данных.
                </p>

                <h5>Внесение изменений в политику конфиденциальности</h5>
                <p>
                  3.1 Настоящая политика конфиденциальности может измененяться,
                  обновляться или дополняться правилами. Изменения,вносимые в
                  политику конфиденциальности, будут опубликованы в этом
                  документе.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer gray="section--gray" />
    </div>
  </div>
</template>

<script>
import HeaderSecondary from '@/components/HeaderSecondary.vue';
import Footer from '@/components/Footer.vue';
import msg from '@/utils/messages';

export default {
  name: 'Home',
  components: {
    HeaderSecondary,
    Footer
  },
  metaInfo() {
    return {
      title: msg.PAGE_TITLE_PRIVACY,
      titleTemplate: `${this.siteName || ''} - %s`
    };
  },
  computed: {
    siteName() {
      return this.$store.getters.getSiteParams?.siteName;
    }
  }
};
</script>
